import { getSearchList } from '@/database/index'

class RelevantControl {
  constructor() {
    this.list = []
  }

  /**
   * 添加检索列表
   * @param {String} content 消息内容 
   */
  async addList (content) {
    if (!content) return
    const params = {
      title: content,
      questionNum: 6
    }
    const result = await getSearchList(params)
    this.list = this.setList(result.questionList)
  }

  /**
   * 列表中关键词标红
   * @param {Array} list 推荐列表 
   */
  setList (list) {
    return list.filter(item => {
      if (item.title) {
        item.titleCopy = item.title.replace(
          item.tagStr,
          `<span>${item.tagStr}</span>`
        )
        return item
      }
    })
  }

  clear() {
    this.list = []
  }
}

export default RelevantControl


// WEBPACK FOOTER //
// ./src/controller/modules/relevantControl.js